export const basicFormData = () => ({
  inputData: {
    stage: "",
    is_active: true,
    created_by: 1,
    updated_by: 1,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "payment_stage_masters",
  };

  const navigatePage = { back: "/stage-list" };

  const headerName = "Payment Stage";

  const validationType = "StageCreate";
  const createEndpoint = "/saveRecords";
  const updateEndpoint = "/saveRecords";
  const getEndpoint = "/getRecords";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
  };
};

export const listPageData = () => {
  const payload = {
    modelName: "payment_stage_masters",
    relations: [
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
    ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "Stage Name", value: "stage" },
    { label: "Created By", value: "createdBy.first_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/stage-create",
    edit: "/stage-create",
    view: "/stage-view",
  };

  const searchfields = [
    "stage",
    "createdBy.first_name",
    "createdBy.last_name",
    "updatedBy.first_name",
    "updatedBy.last_name",
  ];

  const headerName = "Payment Stage";
  const endpoint = "/getRecords";
  const exportFileName = "paymentStageData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};

export const exportPageData = {
  modelName: "payment_stage_masters",
  relations: [
    { module: "user_masters", moduleAs: "createdBy" },
    { module: "user_masters", moduleAs: "updatedBy" },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
